var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSportsnutrition(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65,
    height: 65,
    viewBox: "0 0 98 98.015",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#BE0A75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F4A95"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7131",
    x: 0,
    y: 0,
    width: 98,
    height: 98.015,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.082
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7132",
    x: 44.642,
    y: 29.48,
    width: 37.754,
    height: 55.221,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.082
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sports_nutrition",
    "data-name": "Sports nutrition",
    transform: "translate(8.953 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -8.95, -6)",
    filter: "url(#Path_7131)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7131-2",
    "data-name": "Path 7131",
    d: "M66.989,16.194V12.333h3.079a3.181,3.181,0,0,0,3.177-3.177V8.009a7.983,7.983,0,0,0-3.689-6.745,1.187,1.187,0,0,0-1.282,2c2.829,1.815,2.6,4.667,2.6,5.893a.8.8,0,0,1-.8.8h-31a.8.8,0,0,1-.8-.8V8.009A5.642,5.642,0,0,1,43.9,2.374H64.374a1.187,1.187,0,0,0,0-2.374H43.9a8.018,8.018,0,0,0-8.009,8.009V9.155a3.181,3.181,0,0,0,3.177,3.177h3.079v3.86a13.937,13.937,0,0,0-6.012,1.794A1.187,1.187,0,0,0,37.31,20.05a11.57,11.57,0,0,1,5.721-1.511H66.1A11.583,11.583,0,0,1,77.673,30.11V66.07A11.583,11.583,0,0,1,66.1,77.641c-25.18,0-24.087.143-26.085-.4a11.42,11.42,0,0,0-7.44-20.057H31.46V30.109a11.594,11.594,0,0,1,2.584-7.289,1.187,1.187,0,0,0-1.843-1.5,13.976,13.976,0,0,0-3.115,8.786V57.189H11.46a11.413,11.413,0,1,0,0,22.826H32.579a11.345,11.345,0,0,0,4.949-1.13,13.812,13.812,0,0,0,5.5,1.13H66.1A13.96,13.96,0,0,0,80.047,66.07V30.109A13.961,13.961,0,0,0,66.989,16.194Zm-2.374-.029H44.52V12.333H64.615ZM20.832,77.641H11.46a9.039,9.039,0,1,1,0-18.078h9.372Zm11.746,0H23.206V59.563h9.372a9.039,9.039,0,1,1,0,18.078Z",
    transform: "translate(8.95 6)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -8.95, -6)",
    filter: "url(#Path_7132)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7132-2",
    "data-name": "Path 7132",
    d: "M301.394,190.967a2.311,2.311,0,0,0-4.272-1.229l-11.092,17.886a2.143,2.143,0,0,0,1.787,3.28h4.918c-5.844,12.632-5.6,11.9-5.6,12.612a2.315,2.315,0,0,0,4.084,1.5l7.1-9.568a1.187,1.187,0,1,0-1.906-1.414l-6.673,9,5.3-11.451a2.14,2.14,0,0,0-1.912-3.049h-4.865l10.6-17.089c-4.143,12.062-3.918,11.262-3.918,11.768a2.128,2.128,0,0,0,2.112,2.139h5.8l-3.615,4.874a1.187,1.187,0,1,0,1.906,1.414c4.266-5.751,4.309-5.592,4.309-6.518a2.131,2.131,0,0,0-2.113-2.144h-5.936C301.608,190.746,301.394,191.591,301.394,190.967Z",
    transform: "translate(-232.06 -153.16)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportsnutrition);
export default __webpack_public_path__ + "static/media/Sports nutrition.232f57441df5007d488f0070b91dfbb7.svg";
export { ForwardRef as ReactComponent };